import styled from 'styled-components/macro';

export const Container = styled.div`
  background: #EDEDED;
  border: 1px solid #EDEDED;
  box-sizing: border-box;
  border-radius: 3px;
  height: 28px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  color: #333;
  font-size: 12px;
  & > svg {
    margin-left: 10px;
    cursor: pointer;
  }
`;